import { Badge, Icon, type IconName } from '@speaking-coach/ui'
import type { LifecycleStatus } from './content-history-types'

/** Lifecycle and admission eligibility are deliberately different visual axes. */
interface ContentStatusBadgeProps {
  status: LifecycleStatus | null
  inheritedStatus?: LifecycleStatus | null
  known?: boolean
}

function statusLabel(status: LifecycleStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export function ContentStatusBadge({ status, inheritedStatus = null, known = true }: ContentStatusBadgeProps) {
  const effective = status ?? inheritedStatus
  const icon: IconName = !known || effective === null ? 'unknown'
    : inheritedStatus !== null && status === null ? 'nested'
      : effective === 'active' ? 'current'
        : effective === 'draft' ? 'edit' : 'retire'
  const variant = !known || effective === null ? 'warning'
    : effective === 'active' ? 'neutral' : 'muted'
  const label = !known ? 'Unknown'
    : status ? statusLabel(status)
      : inheritedStatus ? `Inherited: ${statusLabel(inheritedStatus)}`
        : 'Parent unknown'
  return (
    <Badge variant={variant}>
      <Icon name={icon} size={14} className="shrink-0" />
      {label}
    </Badge>
  )
}

export function AvailabilityBadge({ available }: { available: boolean | null }) {
  const icon: IconName = available === null ? 'unknown'
    : available ? 'success' : 'locked'
  const variant = available === null ? 'warning'
    : available ? 'success' : 'muted'
  return (
    <Badge variant={variant}>
      <Icon name={icon} size={14} className="shrink-0" />
      {available === null ? 'Unknown' : available ? 'Available' : 'Not available'}
    </Badge>
  )
}
